// Workspace layout created by tools/gen_web_routes.py; owned by hand from here on.
import { createFileRoute, Outlet } from '@tanstack/react-router'
import { AppShell } from '../../shared/shell/AppShell'

export const Route = createFileRoute('/me')({
  // Guard (signed in): the session and access come from the query cache; a failed check redirects
  // to /sign-in?next=… or renders NotFound for an organization the person is not in (spec 08 § 5).
  beforeLoad: () => {},
  staticData: { workspace: 'me' },
  component: () => (
    <AppShell workspace="me">
      <Outlet />
    </AppShell>
  ),
})
